import { styled } from 'styled-components';

export const DaysTasksContainer = styled.div`
  width: 335px;
  padding: 20px 7px 20px 20px;
  border-radius: 8px;
  border: var(--taskitem-border);
  background: var(--second-Bckg-Color);
  @media screen and (min-width: 768px) {
    width: 344px;
    padding: 20px 6px 20px 20px;
  }
`;
